import React, { useEffect, useState } from "react";
import "../../../assets/fonts/Fonts.css";
import FederalLogo from "../../../assets/images/FEDERAL.png";
import TerengganuLogo from "../../../assets/images/TERENGGANU.png";
import PerlisLogo from "../../../assets/images/PERLIS.png";
import SelangorLogo from "../../../assets/images/SELANGOR.png";
import N9Logo from "../../../assets/images/NEGERI SEMBILAN.png";
import KelantanLogo from "../../../assets/images/KELANTAN.png";
import PerakLogo from "../../../assets/images/PERAK.png";
import KedahLogo from "../../../assets/images/KEDAH.png";
import PahangLogo from "../../../assets/images/PAHANG.png";
import JohorLogo from "../../../assets/images/JOHOR.png";
import SabahLogo from "../../../assets/images/SABAH.png";
import MelakaLogo from "../../../assets/images/MELAKA.png";
import PenangLogo from "../../../assets/images/PULAU PINANG.png";
import SarawakLogo from "../../../assets/images/SARAWAK.png";
import { useNavigate } from "react-router-dom";
import api from "../../../services/baseUrl";

export default function GazetteFinder() {
  const navigate = useNavigate();
  const [libraries, setLibraries] = useState([]);
  const images = [
    { src: FederalLogo, name: "Federal", id: 14 },
    { src: TerengganuLogo, name: "Terengganu", id: 10 },
    { src: PerlisLogo, name: "Perlis", id: 8 },
    { src: SelangorLogo, name: "Selangor", id: 4 },
    { src: N9Logo, name: "Negeri Sembilan", id: 3 },
    { src: KelantanLogo, name: "Kelantan", id: 9 },
    { src: PerakLogo, name: "Perak", id: 5 },
    { src: KedahLogo, name: "Kedah", id: 7 },
    { src: PahangLogo, name: "Pahang", id: 11 },
    { src: JohorLogo, name: "Johor", id: 1 },
    { src: SabahLogo, name: "Sabah", id: 12 },
    { src: MelakaLogo, name: "Melaka", id: 2 },
    { src: PenangLogo, name: "Pulau Pinang", id: 6 },
    { src: SarawakLogo, name: "Sarawak", id: 13 },
  ];

  useEffect(() => {
    const fetchLibraries = async () => {
      try {
        const response = await api.get(
          "/api/egazette-documents/libraries/all",
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const filteredResponse = response.data.filter((item) => item.id !== 0);
        setLibraries(filteredResponse);
      } catch (error) {}
    };
    fetchLibraries();
  }, []);

  return (
    <div className="">
      <div className="gazette-finder-announcement">
        You can now access and retrieve the gazettes as needed. Explore the
        features and enjoy the convenience of quickly purchasing gazettes with
        ease. Happy browsing!
      </div>
      <div className="gazette-finder-content">
        <div className="gazette-finder-state-gallery">
          {libraries?.map((state) => {
            const image = images.find((img) => img.id === state.id);
            return (
              <div
                className="gallery-item"
                key={state.id}
                onClick={() => {
                  navigate(`${state.name.toLowerCase().replace(" ", "-")}`, {
                    state: { state: image },
                  });
                }}
              >
                {image ? (
                  <img
                    src={image.src}
                    alt={`${state.name} Logo`}
                    className="gallery-image"
                  />
                ) : (
                  <p>Image not found</p> // Handle missing images gracefully
                )}
                <p
                  className="gallery-name"
                  dangerouslySetInnerHTML={{
                    __html: state.name.replace(/ /g, "&nbsp;"),
                  }}
                  style={{ cursor: "pointer" }}
                />{" "}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
